import React from "react";
import { Link } from "react-router-dom";

const Product = ({ product }) => {
  const { _id, name, price, image, description, quantity, minimum } = product;
  return (
    <div>
      <div className="mx-5 mb-10  rounded-xl  relative shadow-xl h-[700px] transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300">
        <img
          className="rounded-t-xl w-full mt-3 h-[300px]"
          src={image}
          alt=""
        />
        <h3 className="text-4xl pt-4 text-center text-cyan-800  pb-2">
          {name}
        </h3>
        <div className="text-xl font-sans px-5 ">
          {description.slice(0, 150)}{" "}
          <span className="text-orange-400">
            {description.length > 150 ? "Read More..." : ""}
          </span>
        </div>
        <div className="absolute bottom-0 w-full">
          <div className="text-xl font-sans px-5 ">
            <span className="text-2xl">Price: $</span>
            {price}
          </div>

          <div className="text-xl font-sans px-5 ">
            <span className="text-2xl">Available Quantity: </span>
            {quantity} Unit
          </div>
          <div className="text-xl font-sans px-5 ">
            <span className="text-2xl">Minimum Order: </span>
            {minimum} Unit
          </div>
          <div className=" mt-4 mb-6 flex justify-center">
            <Link
              className="btn btn-primary bg-cyan-800 text-white"
              to={`purchase/${_id}`}
            >
              Purchase
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
